<template>
    <el-card class="page_card" ref="card">
        <div slot="header" class="clearfix" >
            <span>{{title}}</span>
        </div>
        <el-row>
            <el-col :span="24" style="text-align:center;">
                <img style="width: 30%;display:block;margin: 0 auto" src="@/assets/img/deving.png">
                <h3 style="margin: 0 auto;">正在开发中...</h3>
            </el-col>
        </el-row>
    </el-card>
</template>

<script>
export default {
    name: 'development',
    data(){
        return {
            title:""
        }
    },
    methods:{

    },
    created(){
        this.title = this.$route.meta.title;
    }
}
</script>

<style scoped lang="scss">

</style>
